module.exports = __webpack_public_path__ + "img/shield-virus.ea342495.svg";